module.exports = __webpack_public_path__ + "img/cover-0.d50250ea.jpg";